<form [formGroup]="overigeBezittingen">
    <div *ngIf="box3OverigeBezittingen.length > 0">
        <div formArrayName="box3OverigeBezittingen">
            <div *ngFor="let item of box3OverigeBezittingen.controls; let i = index; "
                 [formGroupName]="i" class="row">

                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Soort bezit' : ''"
                                                  [options]="bezitSoort"
                                                  [required]=true
                                                  class="col-auto custom-input-275"
                                                  formControlName="soort"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving bezit' : ''"
                                                class="col-auto  custom-input-275"
                                                formControlName="omschrijving"
                                                id="omschrijving"
                >

                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Waarde op 1 januari ' + this.jaar : ''"
                                                  [minValue]="0"
                                                  [required]=true
                                                  align="right"
                                                  class="col-auto  custom-input-200"
                                                  formControlName="bedrag"
                                                  id="bedrag"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                @if (this.incomeTaxEntity.aangifte?.box3?.berekenWerkelijkRendement) {
                    <snelstart-ui-button
                            (click)="this.showDialog(i)"
                            [class]="i === 0 ? 'me-1 pt-3 custom-input-125' : 'me-1 custom-input-125'"
                            [icon]="heeftOWR[i] ? 'check' : 'plus'"
                            type="secondary">
                        OWR
                    </snelstart-ui-button>
                }
                <snelstart-ui-button (click)="verwijderRijOverigeBezittingen(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="box3OverigeBezittingen.length === 0">
    <snelstart-ui-button (click)="addRijOverigeBezitting()" class="snelstart-ui-button" icon="plus"
                         type="link">Bezit invullen
    </snelstart-ui-button>
</div>
<div *ngIf="box3OverigeBezittingen.length > 0">
    <snelstart-ui-button (click)="addRijOverigeBezitting()" class="snelstart-ui-button" icon="plus"
                         type="link">Bezit toevoegen
    </snelstart-ui-button>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [title]="getOWRDialogTitel(index)"
                                id="owrBank"
                                size="lg">
    <snelstart-ui-dialog-body>
        <form [formGroup]="overigeBezittingen">
            <div *ngIf="box3OverigeBezittingen.length > 0">
                <div formArrayName="box3OverigeBezittingen">
                    <div *ngFor="let item of box3OverigeBezittingen.controls; let i = index; "
                         [formGroupName]="i">
                        <div *ngIf="i === this.index">
                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value !== OverigeBezittingSoort.CONTANT_GELD
                            && this.box3OverigeBezittingen.controls[i]?.get('soort')?.value !== OverigeBezittingSoort.PREMIEDEPOT
                            && this.box3OverigeBezittingen.controls[i]?.get('soort')?.value !== OverigeBezittingSoort.BOUWDEPOT) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Waarde op 31 december ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="waardeEindJaar"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Waarde op 1 januari ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="col-auto  custom-input-275"
                                                                  formControlName="bedrag"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }


                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value === OverigeBezittingSoort.CONTANT_GELD) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="directRendement"
                                                                  id="bedrag"
                                                                  label="Koerswinst/-verlies"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }
                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value === OverigeBezittingSoort.VORDERING) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Ontvangen rente in ' + this.incomeTaxEntity.year "
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="directRendement"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaalbedrag verstrekte leningen in ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="toenames"
                                                                  id="bedrag"
                                                                  label="Verstrekte lening"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaalbedrag aflossingen in ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="afnames"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }
                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value === OverigeBezittingSoort.CRYPTO) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaalbedrag aankopen in ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="toenames"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaalbedrag verkopen in ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="afnames"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }
                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value === OverigeBezittingSoort.KAPITAALVERZEKERING) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaalbedrag betaalde premies in ' + jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="toenames"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }
                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value === OverigeBezittingSoort.PREMIEDEPOT) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Ontvangen rente in ' + this.jaar"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="directRendement"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }
                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value === OverigeBezittingSoort.PERIODIEKE_UITKERING) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaal betaalde premies in ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="toenames"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaal uitkeringen in ' + this.jaar"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="directRendement"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }
                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value === OverigeBezittingSoort.OVERIG) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaal opbrengsten in ' + this.jaar"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="directRendement"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaal aankopen/stortingen in ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="toenames"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Totaal verkopen/onttrekking in ' + this.jaar"
                                                                  [minValue]="0"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="afnames"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }
                            @if (this.box3OverigeBezittingen.controls[i]?.get('soort')?.value === OverigeBezittingSoort.BOUWDEPOT) {
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Bijgeschreven rente in ' + jaar"
                                                                  [required]=true
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="directRendement"
                                                                  id="bedrag"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            }
                            <div class="pt-2 pb-2">
                                <div class="d-flex align-items-center">
                                    <div class="result-inline">
                                        @let rendementOverig = getBerekendeWerkelijkRendement(i);
                                        Werkelijk rendement in {{ jaar }} =
                                        € {{ rendementOverig != null ? (rendementOverig | number:'1.0-2') : '0' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>


